import { useParams } from 'react-router-dom';
import AdminSectionTitle from '../components/AdminSectionTitle';
import EventMenuOption from '../components/EventMenuOption';
import { useGetListByIdQuery } from '../store';
import copyLinkToClipboard from '../utils/copyLinkToClipboard';
import config from '../config/config';
import { IconPlay2, IconPlay1, IconSmile2 } from '../components/icons';
import LoadingLottie from '../components/atoms/LoadingLottie';
import RequireAuth from '../store/utils/RequireAuth';
import useIsBackOffice from '../hooks/useIsBackoffice';

interface Options {
  title: string;
  info: string;
  buttonLabel: string;
  redirectPath?: string;
  onClick?: () => void;
  hidden?: boolean;
  icon: React.ReactNode;
}

const EventListMenu = () => {
  const { list_id: listId } = useParams();
  const { data: list, isLoading: isLoadingList } = useGetListByIdQuery(listId || '');
  const isBackOffice = useIsBackOffice();
  const options: Options[] = [
    {
      title: 'Lista de invitados',
      info: 'En esta sección podras gestionar todas las personas que estarán en la lista  de invitados.',
      buttonLabel: 'Ver listas',
      redirectPath: 'guests',
      icon: <IconSmile2 className='w-10 h-10 ml-2 mt-1' />,
    },
    {
      title: 'Validador de lista',
      info: 'En esta sección podras usar la funcionalidad de validador de nombres y compartir para que otros puedan validar.',
      buttonLabel: 'Ir al validador',
      redirectPath: 'validator',
      icon: <IconPlay2 className='w-10 h-10 ml-2 mt-1' />,
    },
    {
      title: 'Compartir validador',
      info: 'Creá un link para que otro usuario pueda validar las listas',
      buttonLabel: 'Copiar link',
      onClick: () => {
        copyLinkToClipboard(`${config.baseDomain}/lists/${listId}/validator`);
      },
      icon: <IconPlay1 className='w-10 h-10 ml-2 mt-1' />,
      hidden: isBackOffice,
    },
  ];
  if (isLoadingList) {
    return <LoadingLottie />;
  }
  return (
    <RequireAuth>
      <div className='my-6 flex flex-col gap-6 min-h-screen'>
        <AdminSectionTitle
          title={list?.name || 'Listas'}
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 glass-surface">
          {options
            .filter((option) => !option.hidden)
            .map((option) => (
              <div key={option.title} className="mb-3">
                <EventMenuOption
                  id={option.title}
                  title={option.title}
                  info={option.info}
                  buttonLabel={option.buttonLabel}
                  redirectPath={option.redirectPath}
                  onClick={option.onClick}
                  icon={option.icon}
                />
              </div>
            ))}
        </div>
      </div>
    </RequireAuth>
  );
};

export default EventListMenu;
